(function () {
  /* Recurring-purchase consent — ONE implementation, BOTH cart surfaces.
   *
   * This file is not an app script; it is a custom theme asset for this store, and it does
   * three things that have to stay true wherever a cart is shown:
   *   1. inject the consent checkbox above the totals
   *   2. show it ONLY when the cart contains (or is selecting) a subscription
   *   3. GATE CHECKOUT — refuse to proceed until it is ticked
   *
   * It used to run on the sliding drawer only, so /cart could reach checkout with a
   * subscription in the cart and no consent shown at all. Rather than duplicate it, the
   * surface-specific bits are a small adapter and everything else is shared — the copy, the
   * subscription test, the show/hide, the gate message.
   *
   * The two gates differ by necessity, not by choice: the drawer's checkout is a <button> that
   * navigates, so it is cloned and its click intercepted (unchanged from before). The cart
   * page's is an <input type="submit"> inside <form action="/cart">, so cloning would break
   * the form — it is gated with a capture-phase submit listener instead, which also catches
   * Enter-to-submit.
   */

  var COPY =
    'One or more items in your cart is a recurring purchase. By continuing with your payment, ' +
    'you agree that your payment method will automatically be charged at the price and ' +
    'frequency listed on this page until you cancel. All cancellations are subject to the ';
  var POLICY_URL = 'https://www.lemonandco.com/pages/cancelation-policy';
  var BLOCK_MSG = 'Please confirm the subscription terms before continuing to checkout.';

  function consentMarkup() {
    var c = document.createElement('div');
    c.id = 'effectiveAppsAgreeContainer';
    c.style = 'margin-top:15px; display:none;';
    c.innerHTML =
      '<p>' +
      '<input type="checkbox" id="effectiveAppsAgreeCB" ' +
      'style="-webkit-appearance:checkbox; float:none; vertical-align:middle;">' +
      '&nbsp;' +
      '<label for="effectiveAppsAgreeCB" style="display:inline; float:none;">' +
      '<span style="color:rgba(0,0,0,.56); font-size:14px;">' + COPY +
      '<a href="javascript:TAC_openPopup(\'' + POLICY_URL + '\');" ' +
      'style="text-decoration:underline;">cancellation policy</a>.' +
      '</span></label></p>';
    return c;
  }

  var lastHasSubscription = null;

  function isConsented() {
    var cb = document.getElementById('effectiveAppsAgreeCB');
    return !!(cb && cb.checked);
  }
  function mustConsent() { return lastHasSubscription === true; }

  function mountConsent(host) {
    if (!host) return;
    var existing = document.querySelector('#effectiveAppsAgreeContainer');
    if (existing) existing.remove();
    host.prepend(consentMarkup());
  }

  /* Shared: does the cart hold, or is the shopper choosing, a subscription? */
  function checkCartSubscription() {
    return fetch('/cart.js', { credentials: 'include' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (i) { return i.selling_plan_allocation; });
        var selected = Array.prototype.slice
          .call(document.querySelectorAll('.subscribe_button_cart'))
          .some(function (s) { return s.value; });
        var has = inCart || selected;
        if (has !== lastHasSubscription) {
          lastHasSubscription = has;
          var c = document.querySelector('#effectiveAppsAgreeContainer');
          if (c) c.style.display = has ? 'block' : 'none';
          if (!has) {
            var cb = document.getElementById('effectiveAppsAgreeCB');
            if (cb) cb.checked = false;
          }
        }
      })
      .catch(function (e) { console.warn('Cart fetch failed', e); });
  }

  function delayedCheck() {
    setTimeout(checkCartSubscription, 300);
    setTimeout(checkCartSubscription, 600);
    setTimeout(checkCartSubscription, 1000);
  }

  /* ───────────────────────── surface 1: the sliding drawer ───────────────────────── */
  var drawerInitialized = false;

  function drawerEl() { return document.querySelector('.drawer--cart'); }
  function drawerVisible() {
    var d = drawerEl();
    if (!d) return false;
    var s = window.getComputedStyle(d);
    return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }

  function waitForDrawerContent(cb, timeout) {
    var start = Date.now();
    var iv = setInterval(function () {
      var d = drawerEl();
      if (!d || window.getComputedStyle(d).display === 'none') { clearInterval(iv); return; }
      if (d.querySelector('.ajaxcart__footer') && d.querySelectorAll('.cart__checkout').length) {
        clearInterval(iv); cb(d);
      } else if (Date.now() - start > (timeout || 3000)) {
        clearInterval(iv); console.warn('Drawer content timeout');
      }
    }, 100);
  }

  function protectDrawerCheckout(drawer) {
    drawer.querySelectorAll('.cart__checkout').forEach(function (btn) {
      if (btn.dataset.overrideApplied === 'true') btn.dataset.overrideApplied = 'false';
      var clean = btn.cloneNode(true);
      clean.dataset.overrideApplied = 'true';
      btn.parentNode.replaceChild(clean, btn);
      clean.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (mustConsent() && !isConsented()) { alert(BLOCK_MSG); return; }
        window.location.href = '/checkout';
      });
    });
  }

  function bindDrawerEvents(drawer) {
    if (drawer.dataset.eventsAttached === 'true') return;
    drawer.dataset.eventsAttached = 'true';
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('.subscribe_button_cart') ||
          e.target.matches('.ajaxcart__qty-num')) delayedCheck();
    });
    drawer.addEventListener('input', function (e) {
      if (e.target.matches('.ajaxcart__qty-num')) delayedCheck();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.matches('.ajaxcart__qty-remove')) delayedCheck();
    });
    var obs = new MutationObserver(delayedCheck);
    obs.observe(drawer, { childList: true, subtree: true });
    drawer._cartObserver = obs;
  }

  function initDrawer() {
    if (drawerInitialized) return;
    var d = drawerEl();
    if (!d || !drawerVisible()) return;
    drawerInitialized = true;
    waitForDrawerContent(function (drawer) {
      mountConsent(drawer.querySelector('.ajaxcart__footer'));
      protectDrawerCheckout(drawer);
      bindDrawerEvents(drawer);
      checkCartSubscription();
    });
  }

  function resetDrawer() {
    drawerInitialized = false;
    lastHasSubscription = null;
    var d = drawerEl();
    if (d) {
      d.dataset.eventsAttached = 'false';
      if (d._cartObserver) { d._cartObserver.disconnect(); d._cartObserver = null; }
    }
  }

  var lastDrawerVisible = false;
  function checkDrawerVisibility() {
    var v = drawerVisible();
    if (v !== lastDrawerVisible) {
      lastDrawerVisible = v;
      if (v) initDrawer(); else resetDrawer();
    }
  }

  /* ───────────────────────── surface 2: the /cart page ───────────────────────── */
  function initCartPage() {
    var form = document.querySelector('body.template-cart form.cart');
    if (!form || form.dataset.lcConsent === 'true') return;
    form.dataset.lcConsent = 'true';

    /* above the totals, the same position the drawer uses */
    mountConsent(form.querySelector('.grid.cart__row'));

    /* an <input type="submit"> cannot be cloned the way the drawer's button is without
       breaking the form, so the gate is on submit — which also catches Enter. Capture phase,
       so it runs before anything else bound to the form. */
    form.addEventListener('submit', function (e) {
      var by = e.submitter || document.activeElement;
      var isCheckout = by && (by.name === 'checkout' ||
                              (by.className || '').indexOf('cart--button-checkout') > -1);
      if (!isCheckout) return;                    /* "Update cart" is never gated */
      if (mustConsent() && !isConsented()) {
        e.preventDefault(); e.stopPropagation();
        alert(BLOCK_MSG);
      }
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.subscribe_button_cart')) delayedCheck();
    });

    checkCartSubscription();
  }

  /* ───────────────────────── boot ───────────────────────── */
  var observer = new MutationObserver(checkDrawerVisibility);
  observer.observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
  });
  setInterval(checkDrawerVisibility, 200);

  function boot() { checkDrawerVisibility(); initCartPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


function TAC_openPopup(url) {
  var w = 600;
  var h = 850;
  var left = (screen.width / 2) - (w / 2);
  var top = (screen.height / 2) - (h / 2);
  return window.open(url, "", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
}
